import React from 'react';

const PageBreak = ({ ...attrs }) => (
  <svg viewBox="0 0 32 32" {...attrs}>
    <path d="m30.633 16.061-3.4707 0.01172 0.0059 1.7344 3.4707-0.01172zm-5.2051 0.01758-3.4707 0.01172 0.0059 1.7344 3.4707-0.01172zm-5.2051 0.01758-3.4707 0.01172 0.0059 1.7344 3.4707-0.01172zm-5.2051 0.01758-3.4707 0.01172 0.0059 1.7344 3.4707-0.01172zm-5.2051 0.01758-3.4707 0.01172 0.00586 1.7344 3.4707-0.01172zm-5.207 0.01758-3.4688 0.01172 0.00586 1.7344 3.4688-0.01172z" />
    <path d="m3 4.9417v8h26v-8h-1.2422v6.7578h-23.516v-6.7578z" />
    <path d="m3 21v8h1.2617v-6.7383h23.477v6.7383h1.2617v-8h-26z" />
  </svg>
);

export default PageBreak;
